<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      :width="width"
    >

      <div class="d-flex justify-center mt-4 mb-3 px-4 mx-auto">
          <v-row align="center" class="no-gutters">
            <v-col class="text-center" cols="3">
              <v-icon class="logo-icon" color="light-blue">mdi-home</v-icon>
            </v-col>
            <v-col class="text-left logo-text">
              <div class="pl-2">
                <span class="d-block">Rental Property</span>
                <span>Manager</span>
              </div>
            </v-col>
          </v-row>
      </div>
      <v-divider></v-divider>


      <v-list>
        <template v-for="item in menuItems" >
          <v-list-item
            active-class="menuListItem--active"
            v-if="!item.items"
            :key="item.text"
            :to="item.route"
            class="menuListItem"
            link
          >
            <v-list-item-action class="mr-3">
              <v-icon class="menuListItem">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :key="item.text"
            no-action
            :active-class="'menuListItem--active ' + ($props.darkMode ? 'white--text' : 'black--text')"
          >
            <template v-slot:activator>
              <v-list-item-action class="mr-3">
                <v-icon class="menuListItem">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(subitem,index) in item.items"
              :key="index"
              link
              exact
              :class="$props.darkMode ? 'white--text' : 'la-creme black--text'"
              class="menuListItem"
              :to="subitem.route"
            >
              <v-list-item-content>
                <v-list-item-title class="">{{ subitem.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>


        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      dense
      flat
      :dark="$props.darkMode"
      :class="$props.darkMode ? '' : 'la-creme'"
    >
      <v-app-bar-nav-icon aria-label="Toggle Menu" class="d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
        <div class="mr-md-5 mr-2" v-if="userFirstName">
            <v-row align="stretch" justify="space-around">
              <v-col cols="12" class="text-no-wrap text-right">
                <span class="pr-md-3 pr-2">Welcome, <span @click="toggleDevMode" class="font-weight-bold">{{userFirstName}}</span></span>
                <v-divider vertical></v-divider>
                <span class="pl-md-3 pl-2 clickable" tabindex="0" @click="logout">Logout</span>
              </v-col>
            </v-row>
        </div>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'MainMenu',
    props:{
      darkMode:{
        type:Boolean,
        default: false
      },
    },
    computed: {
      ...mapGetters([
        'userFirstName',
        'accountID',
          'devMode'
      ]),
      width() {
        let result = 335;
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': result = 290;
            break;
          case 'sm': result = 330;
            break;
          case 'md': result = 330;
            break;
          case 'lg': result = 330;
            break;
          case 'xl': result = 330;
            break;
        }
        return result;
      },
    },

    data: () => ({
      drawer: null,
      menuItems: [
        {icon: 'mdi-cog-outline', text: 'Dashboard', route: '/'},
        {icon: 'mdi-home-outline', text: 'Properties', route: '/properties', items: [
            {
              text: 'Add New Property',
              route: '/properties/add'
            },
            {
              text: 'All Properties',
              route: '/properties'
            },
        ]},
        {icon: 'mdi-bell-outline', text: 'Reminders', route: '/reminders'},
        {icon: 'mdi-pencil-box-outline', text: 'Maintenance Requests', route: '/maintenance-requests'},
      ],
    }),
    methods: {
      ...mapActions([
        'toggleDevMode',
        'logout',
        'setAccount'
      ]),

    }
  }
</script>

<style lang="scss">
  .menuListItem {
    font-size: 2rem !important;
    &--active{
      font-weight:bold;
    }
  }
  .clickable{
    cursor: pointer;
  }

</style>